import { Wallet } from "@auer-steel/Services/AuerSteelApiModels";
import { InvoicePaymentCollection, InvoicePaymentModel, InvoiceValidationResult } from "@auer-steel/Services/InvoicePaymentService";
import PayInvoiceState from "@auer-steel/Store/Pages/PayInvoice/PayInvoiceState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: PayInvoiceState = {
    getInvoicePaymentsParameter: {},
    invoicePaymentCollection: {
        creditCardValues: {
            expirationMonth: 1,
            expirationYear: new Date().getFullYear(),
        },
        invoicePayments: [],
        achAccountId: undefined,
        paymentInformation: {}
    },
    invoiceValidationResult: {
        isValid: true,
        invoiceProcessingInformation: [],
        validationMessage: ""
    },
    walletsAreLoading: true,
    wallets: [],
};

const reducer = {
    "Pages/PayInvoice/UpdateInvoicePayments": (
        draft: Draft<PayInvoiceState>,
        action: { parameter: InvoicePaymentCollection },
    ) => {
        draft.invoicePaymentCollection = {
            ...action.parameter,
            isSubmitting: draft.invoicePaymentCollection.isSubmitting,
            hasSubmitted: draft.invoicePaymentCollection.hasSubmitted,
        };
    },
    "Pages/PayInvoice/BeginSubmit": (draft: Draft<PayInvoiceState>) => {
        draft.invoicePaymentCollection.hasSubmitted = true;
        draft.invoicePaymentCollection.isSubmitting = true;
    },
    "Pages/PayInvoice/EndSubmit": (draft: Draft<PayInvoiceState>, action: { parameter: InvoicePaymentCollection }) => {
        draft.invoicePaymentCollection.isSubmitting = false;
    },
    "Pages/PayInvoice/UpdateValidationResult": (draft: Draft<PayInvoiceState>, action: { parameter: InvoiceValidationResult }) => {
        draft.invoiceValidationResult = {
            ...action.parameter,
        };
    },
    "Pages/PayInvoice/UpdateAchWallets" : (draft: Draft<PayInvoiceState>, action: { parameter: Wallet[]}) => {
        draft.wallets = action.parameter;
    },
    "Pages/PayInvoice/UpdateAchWalletsAreLoading" : (draft: Draft<PayInvoiceState>, action: { parameter: boolean }) => {
        draft.walletsAreLoading = action.parameter;
    }
};

export default createTypedReducerWithImmer(initialState, reducer);
